<!-- 设备状态管理 -->
<!-- 首页//设备状态统计  -->
<template>
    <div class="box">
      <Title :text="electricity.EquipmentStatistics.Title[0]" :engText="electricity.EquipmentStatistics.Title[1]"></Title>
      <div class="content">
        <div class="top">
          <div class="echarts-content">
            <chart-block ref="echart"></chart-block>
          </div>
        </div>
        <div class="bottom">
          <div class="li ">
            <div>
                <div class="yellow"></div>
                <div class="title">电表 <span>(台)</span></div>
            </div>
            <div>
                <div class="name name1">总数:</div>
                <div class="val val1">{{electricity.EquipmentStatistics.dianbiaoData.total}}</div>
            </div>
            <div>
                <div class="name">在线数:</div>
                <div class="val">{{electricity.EquipmentStatistics.dianbiaoData.onLine}}</div>
            </div>
            <div>
                <div class="name">离线数:</div>
                <div class="val">{{electricity.EquipmentStatistics.dianbiaoData.offLine}}</div>
            </div>
          </div>
          <div class="li">
            <div>
                <div class="blue"></div>
                <div class="title">电气火灾 <span>(台)</span></div>
            </div>
            <div>
                <div class="name name2">总数:</div>
                <div class="val val2">{{electricity.EquipmentStatistics.dianqiData.total}}</div>
            </div>
            <div>
                <div class="name">在线数:</div>
                <div class="val">{{electricity.EquipmentStatistics.dianqiData.onLine}}</div>
            </div>
            <div>
                <div class="name">离线数:</div>
                <div class="val">{{electricity.EquipmentStatistics.dianqiData.offLine}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Title from '../../components/title/index.vue';
  import { mapState,mapActions } from 'pinia' //引入映射函数
  import useStore from '@/store/index' //引入store
  export default {
    components: {
      Title,
    },
    computed:{
      ...mapState(useStore,['electricity']) 
    },
    mounted () {
      this.$refs.echart.setOption(this.electricity.EquipmentStatistics.Option);
    }
  }
  </script>
  
  <style scoped>
  .box{
     width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .content{
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    /* background-color: red; */
  }
  .content .top{
    flex: 1;
    display: flex;
  }
  .content .bottom{
    width: 100%;
    height: 54px;
    /* background: red; */
    display: flex;
    flex-direction: column;
    font-size: 14px;
  }
  .content .bottom .li{
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .content .bottom .li >div{
    display: flex;
    align-items: center;
  }
  .content .bottom .li span{
    font-size: 12px;
  }
  .content .bottom .li >div:nth-child(1){
    width: 100px;
  }
  .content .bottom .li .val,
  .content .bottom .li .name{
    font-size: 12px;
  }
  .content .bottom .li .val{
    color: #fff;
  }
  .content .bottom .li .name,
  .content .bottom .li .title{
    color: #b4caf3;
  }
  .content .bottom .li .val1,
  .content .bottom .li .name1,
  .content .bottom .li .name2,
  .content .bottom .li .val2{
    font-size: 14px;
  }
  .yellow{
    width: 10px;
    height: 10px;
    background: #ffb400;
    margin-right: 5px;
  }
  .blue{
    width: 10px;
    height: 10px;
    background: #4f9bff;
    margin-right: 5px;

  }
  </style>